import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cake, X } from "lucide-react";
import { EASE } from "@/components/motion";

const COLORS = ["#60a5fa", "#818cf8", "#fbbf24", "#34d399", "#f472b6", "#ffffff"];
const PIECES = Array.from({ length: 22 }, (_, i) => ({ x: (i * 37) % 100, d: (i % 5) * 0.15, c: COLORS[i % COLORS.length], r: (i * 47) % 360 }));

export default function BirthdayCard({ user, birthday }) {
  const key = `gim-bday-${user.user_id}-${birthday?.date}`;
  const [hidden, setHidden] = useState(() => localStorage.getItem(key) === "1");
  if (!birthday?.is_today) return null;
  const close = () => {
    localStorage.setItem(key, "1");
    setHidden(true);
  };
  return (
    <AnimatePresence>
      {!hidden && (
        <motion.div initial={{ opacity: 0, y: 24, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} transition={{ duration: 0.7, ease: EASE }} className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-600 via-blue-900 to-slate-900 text-white p-6 shadow-xl" data-testid="birthday-card">
          {PIECES.map((p, i) => (
            <motion.span key={i} className="absolute top-0 w-1.5 h-3 rounded-sm" style={{ left: `${p.x}%`, background: p.c, rotate: p.r }} initial={{ y: -20, opacity: 0 }} animate={{ y: [-20, 220], opacity: [0, 1, 0] }} transition={{ duration: 2.6, delay: p.d, repeat: Infinity, repeatDelay: 1.5, ease: "easeIn" }} />
          ))}
          <button onClick={close} data-testid="birthday-card-close" className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/10 grid place-items-center hover:bg-white/20" aria-label="Tutup"><X className="w-4 h-4" /></button>
          <span className="relative w-12 h-12 rounded-2xl bg-white/15 border border-white/20 grid place-items-center"><Cake className="w-6 h-6 text-amber-300" /></span>
          <p className="relative mt-5 text-xs font-bold uppercase tracking-[0.2em] text-blue-200">Hari ini spesial</p>
          <p className="relative mt-1 text-2xl font-black tracking-tight leading-tight" data-testid="birthday-card-title">Selamat Ulang Tahun ke-{birthday.age}, {user.name.split(" ")[0]}!</p>
          <p className="relative mt-3 text-sm text-white/75 leading-relaxed italic">"TUHAN memberkati engkau dan melindungi engkau; TUHAN menyinari engkau dengan wajah-Nya dan memberi engkau kasih karunia." — Bilangan 6:24-25</p>
          <p className="relative mt-4 text-xs text-white/60">Dengan kasih, keluarga besar GIM Church Makassar.</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
